import type { HTMLAttributes, ReactNode } from "react";
import { cx } from "./cx";

export interface CardProps extends Omit<HTMLAttributes<HTMLDivElement>, "title"> {
  title?: ReactNode;
  /** Optional header-end content (actions). */
  actions?: ReactNode;
  /** Set false to render the body without padding (e.g. wraps a Table edge-to-edge). */
  padded?: boolean;
  children: ReactNode;
}

/** Card — the flat raised surface (functional elevation e1). Not a marketing card. */
export function Card({ title, actions, padded = true, children, className, ...rest }: CardProps) {
  return (
    <section className={cx("nv-card", className)} {...rest}>
      {(title || actions) && (
        <header className="nv-card__header">
          {title && <h2 className="nv-card__title">{title}</h2>}
          {actions}
        </header>
      )}
      <div className={padded ? "nv-card__body" : undefined}>{children}</div>
    </section>
  );
}
